<template>
  <SidebarComponent />
  <div class="dashboard-layout">
    <div class="content-container">
      <div class="card-container">

        <div class="search-container">
<button @click="goToOrder" class="create-user-button staff-button-positive"><span class="material-icons">add_circle_outline</span> Crea un ordine</button>
<button @click="exportToCSV" class="create-user-button staff-button-neutral"><span class="material-icons">download</span> Export.csv</button>

        </div>
      <div class="columns-container">
        <!-- Colonna Sinistra: Filtro e Lista delle Spese -->
        <div class="column left-column">
          <h3>Elenco Uscite</h3>


          <!-- Filtro per Data -->
<div class="filter-container">
  <label for="startDate">Da:</label>
  <input type="date" id="startDate" v-model="filtroData.inizio" />

  <label for="endDate">A:</label>
  <input type="date" id="endDate" v-model="filtroData.fine" />

  <button @click="filtraSpese" class="filter-button">Cerca</button>
</div>



          <!-- Tabella delle Spese -->
          <table class="spese-table">
            <thead>
              <tr>
                <th>Data</th>
                <th>Prezzo</th>
                <th>Descrizione</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="uscita in speseFiltrate" :key="uscita.id">
                <td>{{ formatDate(uscita.data) }}</td>
                <td>€{{ uscita.prezzo }}</td>
                <td>{{ uscita.descrizione }}</td>
              </tr>
            </tbody>
          </table>

          <!-- Totale delle Spese Filtrate -->
          <div class="totale-container">
            <strong>Totale:</strong> €{{ totaleSpese }}
          </div>
        </div>

        <!-- Colonna Destra: Modulo per Inserire una Spesa -->
        <div class="column right-column">
          <h3>Aggiungi Spesa</h3>
          <form @submit.prevent="aggiungiUscita" class="spesa-form">
            <div class="form-group">
              <label for="data">Data:</label>
              <input type="date" id="data" v-model="uscita.data" required class="user-input" />
            </div>
            <div class="form-group">
              <label for="prezzo">Prezzo:</label>
              <input type="number" id="prezzo" v-model="uscita.prezzo" step="0.01" required class="user-input" />
            </div>
            <div class="form-group">
              <label for="descrizione">Descrizione:</label>
              <textarea id="descrizione" v-model="uscita.descrizione" required class="user-textarea"></textarea>
            </div>
            <button type="submit" class="button-container staff-button-positive"><span class="material-icons">save</span>Salva Spesa</button>
          </form>
        </div>
      </div>
    </div>
  </div>
  </div>
</template>



<script>
import { ref, onMounted, computed } from "vue";
import { getFirestore, collection, query, where, getDocs, addDoc, Timestamp } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import SidebarComponent from "../SidebarComponent.vue";
import { useRouter } from 'vue-router';


export default {
  components: {
    SidebarComponent,
  },
  name: "UsciteComponent",
  setup() {
    const router = useRouter();
    const db = getFirestore();
    const auth = getAuth();
    const uscita = ref({
      data: "",
      prezzo: "",
      descrizione: "",
      uid: "",
    });
    const uscite = ref([]); // Tutte le spese
    const speseFiltrate = ref([]); // Spese filtrate da visualizzare
    const filtroData = ref({
      inizio: "",
      fine: "",
    });
    const user = ref(null);


    const goToOrder = () => {
      router.push('/order');
    };


    const aggiungiUscita = async () => {
      try {
        user.value = auth.currentUser;
        if (!user.value) {
          alert("Devi essere autenticato per salvare una spesa.");
          return;
        }
        uscita.value.uid = user.value.uid;

        const newUscita = {
          ...uscita.value,
          data: Timestamp.fromDate(new Date(uscita.value.data)),
        };

        const docRef = await addDoc(collection(db, "uscite"), newUscita);

        uscite.value.unshift({
          id: docRef.id,
          ...newUscita,
          data: new Date(uscita.value.data),
        });
        ordinaSpese();
        filtraSpese(); // Aggiorna filtro dopo l'aggiunta

        uscita.value = { data: "", prezzo: "", descrizione: "", uid: "" };
        alert("Spesa salvata correttamente!");
      } catch (error) {
        console.error("Errore nel salvataggio dell'uscita:", error);
        alert("Errore nel salvataggio dell'uscita.");
      }
    };

    const caricaUscite = async () => {
      try {
        user.value = auth.currentUser;
        if (!user.value) {
          console.error("Utente non autenticato.");
          return;
        }

        const q = query(
          collection(db, "uscite"),
          where("uid", "==", user.value.uid)
        );
        const querySnapshot = await getDocs(q);
        uscite.value = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
          data: doc.data().data.toDate(),
        }));
        ordinaSpese();
        filtraSpese(); // Filtra dopo il caricamento
      } catch (error) {
        console.error("Errore nel caricamento delle uscite:", error);
      }
    };

    const ordinaSpese = () => {
      uscite.value.sort((a, b) => b.data - a.data);
    };

    const filtraSpese = () => {
  const inizio = filtroData.value.inizio ? new Date(filtroData.value.inizio) : null;
  const fine = filtroData.value.fine ? new Date(filtroData.value.fine) : null;

  if (!inizio || !fine) {
    return; // Evita il filtro se le date non sono impostate
  }

  fine.setHours(23, 59, 59, 999); // Includi l'intera giornata finale

  speseFiltrate.value = uscite.value.filter((uscita) => {
    const dataUscita = uscita.data;
    return dataUscita >= inizio && dataUscita <= fine;
  });
};



    const totaleSpese = computed(() => {
      return speseFiltrate.value.reduce((totale, uscita) => totale + parseFloat(uscita.prezzo), 0).toFixed(2);
    });

    const formatDate = (date) => {
      if (!date) return "";
      const giorno = date.getDate().toString().padStart(2, "0");
      const mese = (date.getMonth() + 1).toString().padStart(2, "0");
      const anno = date.getFullYear();
      return `${giorno}/${mese}/${anno}`;
    };

    onMounted(async () => {
  await caricaUscite(); // Carica tutte le uscite

  const today = new Date().toISOString().split("T")[0]; // Data di oggi in formato YYYY-MM-DD
  filtroData.value.inizio = today;
  filtroData.value.fine = today;

  // Filtra automaticamente se ci sono uscite
  if (uscite.value.length > 0) {
    filtraSpese();
  }
});


    return {
      uscita,
      uscite,
      speseFiltrate,
      filtroData,
      aggiungiUscita,
      caricaUscite,
      filtraSpese,
      totaleSpese,
      formatDate,
      goToOrder
    };
  },
};
</script>



<style scoped>

.search-container {
  margin-bottom: 20px;
}
.filter-button {
  margin-left: 10px;
  padding: 10px 15px;
  background-color: #c1c1c1;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}
.filter-button:hover {
  background-color: #45a049;
}


.totale-container {
  margin-top: 1rem;
  font-size: 1.2rem;
  text-align: right;
}


.filter-container {
  margin-bottom: 1rem;
  display: flex;
  gap: 1rem;
  align-items: center;
}

.filter-container input {
  padding: 0.5rem;
  border: 1px solid #ddd;
  border-radius: 5px;
}


.user-input[data-v-5f783a85], .user-textarea[data-v-5f783a85] {
width: 95%;
padding: 0.5rem;
border: 1px solid #ddd;
border-radius: 5px;
}


.content-container {
  position: relative;
flex-grow: 1;
padding: 100px 20px 0 var(--staff-content-inset, 297px);
overflow-y: auto;
max-width: 95%;
transition: padding-left 0.3s;
}

.columns-container {
  display: flex;
  gap: 1.5rem;
}

.column {
  flex: 1;
  background-color: #f9f9f9;
  padding: 1rem;
  border: 1px solid #ddd;
  border-radius: 5px;
}

.left-column {
  flex: 2; /* Colonna più larga per la tabella */
}

.right-column {
  flex: 1; /* Colonna più stretta per il modulo */
}

h3 {
  margin-bottom: 1rem;
  font-size: 1.2rem;
}

.spese-table {
  width: 100%;
  border-collapse: collapse;
  text-align: left;
}

.spese-table thead {
  background-color: #c1c1c1;
  color: white;
}

.spese-table th,
.spese-table td {
  padding: 0.5rem;
  border: 1px solid #ddd;
}

.spese-table tbody tr:nth-child(even) {
  background-color: #f2f2f2;
}

.spesa-form .form-group {
  margin-bottom: 1rem;
}

.user-input,
.user-textarea {
  width: 100%;
  padding: 0.5rem;
  border: 1px solid #ddd;
  border-radius: 5px;
}

.button-container {
  display: flex;
  align-items: center;
  padding: 10px 15px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 14px;
  cursor: pointer;
  width: 100%;
}

.button-container:hover {
  background-color: #0056b3;
}
</style>
